import { useMemo, useState, useEffect } from 'react';

import { useOperatorsQuery } from '@app/services/operator';
import { type Job } from '@app/types/api/job';
import { type User } from '@app/types/api/user';

const usePreloadOperators = (jobs: Job[]) => {
  const [selectedOperatorsMap, setSelectedOperatorsMap] = useState<
  Map<string, User>
  >(new Map());
  const preSelectedOperatorIds = useMemo(
    () => jobs?.map((job) => job?.assignedOperator?.id || job?.primaryContactId)
      || [],
    [jobs],
  );
  const operatorQuery = useOperatorsQuery({
    ids:
      preSelectedOperatorIds?.filter(
        (id): id is string => id !== undefined && !selectedOperatorsMap.has(id),
      ) || [],
  });

  const { data: selectedOperatorsData, isLoading: isLoadingPreSelectedOperators } = operatorQuery;

  useEffect(() => {
    const operators = selectedOperatorsData?.pages.reduce((accumulator: User[], item) => {
      const ops = item.operators || [];
      return [...accumulator, ...ops];
    }, []) || [];
    const map = new Map();
    for (let i = 0; i < operators.length; i += 1) {
      const operator = operators[i];
      map.set(operator?.id, operator);
    }
    setSelectedOperatorsMap((prevMap) => new Map([...prevMap, ...map]));
  }, [selectedOperatorsData?.pages]);

  return { selectedOperatorsMap, isLoadingPreSelectedOperators };
};

export default usePreloadOperators;
